import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
  brand_name: "CoachScore",
  headline: "",
  subheadline: "",
  headline_tr: "",
  subheadline_tr: "",
  brand_color: "#6366F1",
  logo_path: "",
  intro_video_url: "",
};

export function logoUrlFor(logo_path) {
  return logo_path ? `${API}/files/${logo_path}` : "";
}

// Picks the language-specific branding field (falls back to the English one).
export function localizedBranding(branding, key, lang) {
  if (lang === "tr") return branding?.[`${key}_tr`] || branding?.[key] || "";
  return branding?.[key] || "";
}

export function useBranding() {
  const [branding, setBranding] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/branding`)
      .then((r) => setBranding({ ...DEFAULTS, ...r.data }))
      .catch(() => setBranding(DEFAULTS))
      .finally(() => setLoaded(true));
  }, []);

  return { branding, logoUrl: logoUrlFor(branding.logo_path), loaded };
}
